module.exports = __webpack_public_path__ + "d84d5814e1d75383d559542be5173a14.svg";